import React from 'react';

/** 4SHINE: groen blok met witte «4», geen kader — zelfde beeld als favicon. */
const GREEN = '#3FDFCF';

export default function FourShineMark({ size = 18, className = '', decorative = false }) {
  return (
    <svg
      className={className ? `fourshine-mark ${className}` : 'fourshine-mark'}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-hidden={decorative ? true : undefined}
      role={decorative ? 'presentation' : 'img'}
    >
      <rect width="32" height="32" rx="5" fill={GREEN} />
      <text
        x="16"
        y="23"
        textAnchor="middle"
        fill="#fff"
        style={{
          fontFamily: 'system-ui, -apple-system, "Segoe UI", sans-serif',
          fontWeight: 800,
          fontSize: '19px',
        }}
      >
        4
      </text>
    </svg>
  );
}
